import { Pipe, PipeTransform } from '@angular/core';
import {MeasurementPrecisionTypes} from "@model";
import {localizedDateString, milisecondsToPrecision} from "@utility";

@Pipe({
    name: 'resultDateTime',
    standalone: false
})
export class ResultDateTimePipe implements PipeTransform {

  transform(dateTime?: string, milliseconds?: number, measurementPrecisionType?: MeasurementPrecisionTypes | undefined, timeOnly?: boolean, dateOnly?: boolean): string {
    const format = dateOnly
        ? 'dd.MM.yyyy'
        : timeOnly
            ? 'HH:mm:ss'
            : 'dd.MM.yyyy HH:mm:ss';
    if (!dateTime) {
      return '-';
    } else if (milliseconds === undefined || milliseconds === null || milliseconds === 0) {
      try {
        const date = new Date(dateTime.replace(' ', 'T'));
        return localizedDateString(date, format);
      } catch (e) {
        return `${dateTime}`;
      }
    }
    try {
      const date = new Date(dateTime.replace(' ', 'T'));
      let millisecondFromDate = date.getHours()* 3600000 + date.getMinutes() * 60000 + date.getSeconds() * 1000 + date.getMilliseconds();
      millisecondFromDate = millisecondFromDate + (milliseconds ?? 0);
      const time = milisecondsToPrecision(millisecondFromDate, measurementPrecisionType!);
      const formattedDate = localizedDateString(date, 'dd.MM.yyyy');
      return `${timeOnly ? '' : formattedDate} ${dateOnly ? '' : time}`.trim();
    } catch (e) {
      return `${localizedDateString(dateTime, format)}${!dateOnly && milliseconds ? '.' + milliseconds : ''}`;
    }
  }
}
